import {useState} from "react";
import {ApiBusinessProto, com, space} from "../../provider_api";
import {useRpcSender} from "../RpcSender";
import {useProviderProfile} from "../../ProviderProfileProvider";
import {RpcState} from "../RpcState";
import GetSubscriptionStatusResponse = com.onkensu.platform.billing.GetSubscriptionStatusResponse;
import IBusinessSubscriptionProto = space.kenko.proto.IBusinessSubscriptionProto;

export const useStripeMembershipStatusRpc = () => {

  const rpcSender = useRpcSender();
  const {business, setBusiness} = useProviderProfile();

  const [rpcState, setRpcState] = useState<RpcState>({state: "none"});
  const [membership, setMembership] = useState<IBusinessSubscriptionProto | null>();
  
  const send = () => {

    setRpcState({state: 'pending'});
    rpcSender.send('get_membership_status', new Uint8Array())
        .then(r => {
          const response = GetSubscriptionStatusResponse.decode(r);
          if (!response.okay) {
            setRpcState({state: 'error', message: 'unknown error fetching login'});
            return;
          }

          setMembership(response.updatedSubscription);
          setBusiness(new ApiBusinessProto({
            ...business,
            subscription: response.updatedSubscription
          }));
          setRpcState({state: 'success'});

        })
        .catch(e => {
          setRpcState({state: 'error', message: e});
        })
  }

  return {rpcState, membership, send};
}